import { Injector } from '@angular/core';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { TableDataSource } from '@shared/table/table.datasource';
import { finalize } from 'rxjs/operators';

export class InvoicesDataSource extends TableDataSource {
  private storage: LocalStorageService;
  constructor(injector: Injector) {
    super(injector);
    this.storage = injector.get(LocalStorageService);
  }

  loadData(): void {
    this.onLoadDataStart();
    this.api.accounts.byId.invoices
      .get(this.storage.userWithToken.account_id)
      .pipe(finalize(() => this.onLoadDataEnd()))
      .subscribe((paginatedInvoices) => {
        this.paginatedGet.next(paginatedInvoices);
      });
  }
}
